import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
import CTA from '../cta';
import { breakpoint } from '../theme/breakpoint';

export const StyledExitButton = styled(CTA)`
  background-color: ${({ theme }) => theme.palette.quickExitBlue};
  color: #ffffff;
  padding: ${({ theme }) => theme.spacing.standard};
  text-transform: uppercase;
  z-index: 999; // make sure it's on top of the modal
  position: fixed;

  // Styling for mobile and tablet
  left: 0;
  bottom: 0;
  width: 100%;
  transform: none;
  display: block;

  // Styling for desktop

  ${breakpoint.desktop`          
    top: 380px;
    right: 0;
    left: auto;
    bottom: auto;
    width: auto;
    transform: rotate(90deg);
    transform-origin: top right;
  `}

  &:hover {
    opacity: 0.7;
  }

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px; // according to Figma prototype
  }
`;

export const SVGIcon = styled(SVG)`
  display: inline-block;
  width: 18px; // according to Figma prototype
  height: 18px; // according to Figma prototype
  ${({ $rotate }) =>
    $rotate &&
    css`
      transform: rotate(${$rotate}deg);
    `}
`;
